import { MemberCreatePage } from "@pages/memberCreate";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/members/enroll")({
  component: MemberCreatePage,
});
